import { store } from '@/decorators/store';
import { MetaData } from '@/entities/MetaData';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';
import { IRequiredFields } from '~/api/IRequiredFields';

@store({ id: 'MetaDataStore' })
export class MetaDataStore extends AbstractEntityStore<MetaData> {
  protected entityIdKey = 'listType';
  protected entityLabelKey = 'items';
  protected entityValueKey = 'items';

  protected callTakingRequiredFields: IRequiredFields[] = [];

  updateCallTakingRequiredFields(entities: IRequiredFields[]) {
    this.callTakingRequiredFields = entities;
  }

  get allCallTakingRequiredFields() {
    return [...this.callTakingRequiredFields];
  }
}
